"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchSchedulesVisits = exports.CALENDAR_TABS = void 0;
const domain_1 = require("@home-health-notify/domain");
const dayjs_1 = __importDefault(require("dayjs"));
const react_1 = __importStar(require("react"));
const context_1 = require("../context");
var CALENDAR_TABS;
(function (CALENDAR_TABS) {
    CALENDAR_TABS[CALENDAR_TABS["COMPLETED"] = 0] = "COMPLETED";
    CALENDAR_TABS[CALENDAR_TABS["PROJECTED"] = 1] = "PROJECTED";
})(CALENDAR_TABS || (exports.CALENDAR_TABS = CALENDAR_TABS = {}));
const useFetchSchedulesVisits = ({ info, }) => {
    const { selectedOrgUser } = (0, react_1.useContext)(context_1.OrganizationContext);
    const isPrivateChat = info && info.chatType === domain_1.CHAT_TYPE.PRIVATE;
    const isGroupChat = info && info.chatType === domain_1.CHAT_TYPE.GROUP;
    const [scheduledVisits, setScheduledVisits] = react_1.default.useState([]);
    const fetchSchedulesVisits = (startDate, endDate, currentTab) => __awaiter(void 0, void 0, void 0, function* () {
        const requestParams = Object.assign(Object.assign(Object.assign({ type: currentTab === CALENDAR_TABS.COMPLETED
                ? domain_1.CALENDAR_EVENT_TYPE.COMPLETED
                : domain_1.CALENDAR_EVENT_TYPE.PROJECTED, startDate,
            endDate }, (info && isGroupChat && { chatId: info.id })), (info && isPrivateChat && { otherUserId: info.id })), (info && { chatType: info.chatType }));
        try {
            const scheduledVisits = yield selectedOrgUser.getScheduledVisits(requestParams);
            const mappedScheduledVisits = scheduledVisits.map(visit => (Object.assign(Object.assign({}, visit), { schedulerTime: visit.schedulerTime, schedulerEndTime: visit.schedulerEndTime
                    ? visit.schedulerEndTime
                    : visit.schedulerTime
                        ? (0, dayjs_1.default)(visit.schedulerTime).add(2, "hour").valueOf()
                        : undefined })));
            setScheduledVisits(mappedScheduledVisits);
        }
        catch (error) {
            console.error("[useFetchSchedulesVisits] Error fetching visits:", error);
            throw error;
        }
    });
    return {
        fetchSchedulesVisits,
        scheduledVisits,
    };
};
exports.useFetchSchedulesVisits = useFetchSchedulesVisits;
